import Vue from "vue";
import Router from "vue-router";
import Userauth from "../auth/js/index";
import Body from "../components/body";
import Auth from "../auth/auth";

/* Auth */
import login from "../auth/login";
import Register from "../auth/register";
import resetPassword from '../auth/reset-password.vue'

/* maintenance */
import Maintenance from "../pages/maintenance";

/* Error Pages */
import Error400 from "../errors/error_400";
import Error401 from "../errors/error_401";
import Error403 from "../errors/error_403";
import Error404 from "../errors/error_404";
import Error500 from "../errors/error_500";
import Error503 from "../errors/error_503";

/* comingsoon */
import ComingsoonSimple from "../pages/comingsoon/comingsoon_simple";
import ComingsoonImage from "../pages/comingsoon/comingsoon_image";
import ComingsoonVideo from "../pages/comingsoon/comingsoon_video";

/* Authentication */
import LoginOne from "../pages/authentication/login_one";
import LoginTwo from "../pages/authentication/login_two";
import LoginValidate from "../pages/authentication/login_with_validation";
import RegisterImage from "../pages/authentication/register_image";
import RegisterImage2 from "../pages/authentication/register_image2";
import Unlock from "../pages/authentication/unlock";
import ForgetPassword from "../pages/authentication/forget_password";
import ResetPassword from "../pages/authentication/reset_password";


// QuickCV
// Dashboard
import Dashboard from "../pages/project-doc/dashboard/dashboard.vue";

// System
import paymentLog from "../pages/project-doc/system/payment/log.vue";
import packageList from "../pages/project-doc/system/package/package.vue";
import coupon from "../pages/project-doc/system/coupon/coupon.vue";
import coin from "../pages/project-doc/system/coin/coin.vue";

// AI Hub
import APIKey from "../pages/project-doc/ai/api-key/key.vue";
import PromptCategory from "../pages/project-doc/ai/prompt/category.vue";
import PromptTemplate from "../pages/project-doc/ai/prompt/template.vue";

// Course
import EBook from "../pages/project-doc/system/course/e-book.vue";
import Partner from "../pages/project-doc/system/course/partner.vue";
import Course from "../pages/project-doc/system/course/course.vue";
import CourseCategory from "../pages/project-doc/system/course/category.vue";

// Subscription
import userList from "../pages/project-doc/subscriber/user.vue";
import paymentInitiated from "../pages/project-doc/subscriber/payment-initiated.vue";
import expiringSoon from "../pages/project-doc/subscriber/expiring-soon.vue";
import activeList from "../pages/project-doc/subscriber/active.vue";
import expiredList from "../pages/project-doc/subscriber/expired.vue";
import userWallet from "../pages/project-doc/subscriber/wallet-history.vue";

// Operation
import Label from "../pages/project-doc/operation/label.vue";
import Language from "../pages/project-doc/operation/language.vue";
import DigitalSkill from "../pages/project-doc/operation/digital-skill.vue";
import SidebarMenu from "../pages/project-doc/operation/sidebar.vue";

// Feedback
import Feedback from "../pages/project-doc/feedback/feedback.vue";

import {store} from "@/store";

Vue.use(Router);

const routes = [
    // QuickCV
    {
        path: "/dashboard",
        component: Body,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "main",
                name: "dashboard",
                component: Dashboard,
                meta: {
                    title: "Dashboard"
                }
            },
            {
                path: "",
                name: "dashboard",
                component: Dashboard,
                meta: {
                    title: "Dashboard"
                }
            }
        ]
    },

    {
        path: "/feedback",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "list",
                name: "Feedback",
                component: Feedback,
                meta: {
                    title: "Feedback"
                }
            }
        ]
    },

    {
        path: "/operation",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "cv-tracking-label",
                name: "Label",
                component: Label,
                meta: {
                    title: "CV Tracking Label"
                }
            },
            {
                path: "language",
                name: "Language",
                component: Language,
                meta: {
                    title: "Language"
                }
            },
            {
                path: "digital-skill",
                name: "DigitalSkill",
                component: DigitalSkill,
                meta: {
                    title: "Digital Skill"
                }
            },
            {
                path: "sidebar-menu",
                name: "SidebarMenu",
                component: SidebarMenu,
                meta: {
                    title: "Sidebar Menu"
                }
            }
        ]
    },

    {
        path: "/system",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "payment-log",
                name: "paymentLog",
                component: paymentLog,
                meta: {
                    title: "Payment Log"
                }
            },
            {
                path: "package",
                name: "package",
                component: packageList,
                meta: {
                    title: "Package"
                }
            },
            {
                path: "coupon",
                name: "coupon",
                component: coupon,
                meta: {
                    title: "Coupon"
                }
            },
            {
                path: "coin-feature",
                name: "coin",
                component: coin,
                meta: {
                    title: "Coin Feature"
                }
            }
        ]
    },

    {
        path: "/ai",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "openai-api-key",
                name: "APIKey",
                component: APIKey,
                meta: {
                    title: "ChatGPT API Key"
                }
            },
            {
                path: "prompt-category",
                name: "PromptCategory",
                component: PromptCategory,
                meta: {
                    title: "Prompt Category"
                }
            },
            {
                path: "prompt-template",
                name: "PromptTemplate",
                component: PromptTemplate,
                meta: {
                    title: "Prompt Template"
                }
            }
        ]
    },

    {
        path: "/course",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "e-book/list",
                name: "EBook",
                component: EBook,
                meta: {
                    title: "E-Book"
                }
            },
            {
                path: "partner",
                name: "Partner",
                component: Partner,
                meta: {
                    title: "Partner"
                }
            },
            {
                path: "list",
                name: "Course",
                component: Course,
                meta: {
                    title: "Course"
                }
            },
            {
                path: "category",
                name: "CourseCategory",
                component: CourseCategory,
                meta: {
                    title: "Category"
                }
            }
        ]
    },

    {
        path: "/subscription",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "user/list",
                name: "userList",
                component: userList,
                meta: {
                    title: "User"
                }
            },
            {
                path: "payment-initiated/list",
                name: "paymentInitiated",
                component: paymentInitiated,
                meta: {
                    title: "Payment Initiated"
                }
            },
            {
                path: "expiring/list",
                name: "expiringSoon",
                component: expiringSoon,
                meta: {
                    title: "Expiring Soon"
                }
            },
            {
                path: "activated/list",
                name: "activeList",
                component: activeList,
                meta: {
                    title: "Paid & Activated"
                }
            },
            {
                path: "expired/list",
                name: "expiredList",
                component: expiredList,
                meta: {
                    title: "Expired"
                }
            },
            {
                path: "user/wallet",
                name: "userWallet",
                component: userWallet,
                meta: {
                    title: "Wallet History"
                }
            }
        ]
    },

    //Notifier
    {
        path: "/auth",
        component: Auth,
        children: [
            {
                path: "login",
                name: "Login 1",
                component: login,
                meta: {
                    title: " login",
                }
            },
            {
                path: "register",
                name: "register 1",
                component: Register,
                meta: {
                    title: " Register | Ambala",
                }
            },
            {
                path: "reset-password",
                name: "Reset Password",
                component: resetPassword,
                meta: {
                    title: " Reset Password"
                }
            }
        ]
    },

    { path: "", redirect: "/dashboard/main" },
    { path: "/dashboard", redirect: "/dashboard/main" },

    {
        path: "/error-400",
        name: "Error400",
        component: Error400,
        meta: {
            title: "Error400 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-401",
        name: "Error401",
        component: Error401,
        meta: {
            title: "Error401 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-403",
        name: "Error403",
        component: Error403,
        meta: {
            title: "Error403 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-404",
        name: "Error404",
        component: Error404,
        meta: {
            title: "Error404 | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/error-500",
        name: "Error500",
        component: Error500,
        meta: {
            title: "Error500 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-503",
        name: "Error503",
        component: Error503,
        meta: {
            title: "Error503 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/maintenance",
        name: "Maintenance",
        component: Maintenance,
        meta: {
            title: "Maintenance | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/comingsoon/comingsoon-simple",
        name: "ComingsoonSimple",
        component: ComingsoonSimple,
        meta: {
            title: "ComingsoonSimple | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/comingsoon/comingsoon-image",
        name: "ComingsoonImage",
        component: ComingsoonImage,
        meta: {
            title: "ComingsoonImage | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/comingsoon/comingsoon-video",
        name: "ComingsoonVideo",
        component: ComingsoonVideo,
        meta: {
            title: "ComingsoonVideo | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/login/one",
        name: "LoginOne",
        component: LoginOne,
        meta: {
            title: "LoginOne | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/login/two",
        name: "LoginTwo",
        component: LoginTwo,
        meta: {
            title: "LoginTwo | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/login/validate",
        name: "LoginValidate",
        component: LoginValidate,
        meta: {
            title: "LoginValidate | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/register/image",
        name: "RegisterImage",
        component: RegisterImage,
        meta: {
            title: "RegisterImage | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/register/image2",
        name: "RegisterImage2",
        component: RegisterImage2,
        meta: {
            title: "RegisterImage2 | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/unlockuser",
        name: "Unlock",
        component: Unlock,
        meta: {
            title: "Unlock | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/forgetpassword",
        name: "ForgetPassword",
        component: ForgetPassword,
        meta: {
            title: "ForgetPassword | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/resetpassword",
        name: "ResetPassword",
        component: ResetPassword,
        meta: {
            title: "ResetPassword | Cuba - Premium Admin Template",
        }
    }
];

const router = new Router({
    routes,
    base: process.env.BASE_URL,
    mode: "history",
    linkActiveClass: "active",
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

router.beforeEach((to, from, next) => {
    // console.log("started")
    if (to.meta.title) document.title = to.meta.title;
    let CurrentUser = localStorage.getItem('user') == null ? false : true;

    const allowedPaths = [
        "/auth/login",
        "/auth/register",
        "/auth/reset-password",
        "/auth/reset"
    ];

    const notAllowedWhenLoggedIn =[
        "/auth/login",
        "/auth/register",
        "/auth/reset-password",
        "/auth/reset"
    ];

    const JWTuser = localStorage.getItem("user");

    const matchPath = (path) => {
        return allowedPaths.some(allowedPath => {
            if (allowedPath.includes(":")) {
                const regexPath = allowedPath.replace(/:\w+/g, "\\w+");
                const regex = new RegExp(`^${regexPath}$`);
                return regex.test(path);
            }
            return allowedPath === path;
        });
    };

    if ( matchPath(to.path)){
        console.log("allowed path")
        if(notAllowedWhenLoggedIn.includes(to.path)) {
            if(CurrentUser)
                return next({
                    path: '/dashboard/main',
                });
        }
        return next()
    }else{
        store.dispatch('authentication/verify_token', localStorage.getItem("access_token")).then(result=>{
            console.log("after verify", result)
        })
    }

    if( to.path === "/callback" ||
        CurrentUser ||
        Userauth.isAuthenticatedUser() ||
        JWTuser
    ) {
        return next();
    }

    next({
        path: '/auth/login',
        query: { redirect: to.fullPath }
    });
});

export default router;
